import React, { useEffect, useState } from "react";
import {
  DndContext,
  useDraggable,
  useDroppable,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { BreadCrumbsAndTitle } from "../../components/generics/BreadCrumbsAndTitle";
import { AlertsInformativos } from "../../components/generics/AlertsInformativos";
import { mtDividerUpTable, paddingCardsTables } from "../../commons";
import { alertInformativo } from "../../commons/texts";
import { hasPemissions } from "../../commons/utils";
import { CreateDialogTipoCotizacion } from "../../features/tipo-cotizacion/modals";
import {
  getAllTipoCotizacionCamposRedux,
  getAllTipoCotizacionRedux,
  removeCamposTipoOrdenesServicios,
} from "../../store/tipo-cotizacion";
import { useDispatch, useSelector } from "react-redux";
import { ICampoOrdenServicio, ITipoCotizacion } from "../../commons/interfaces";
import { styled } from "@mui/material/styles";
import {
  getAllQuotationFieldRedux,
  storeCreateCamposTipoOrdenesServicios,
} from "../../store/ordenes-de-servicios";

// --- Mantengo exactamente las interfaces/nombres que usabas ---
interface QuotationField {
  id: string;
  fieldLabel: string;
  fieldType: string;
}

interface QuotationType {
  relationId: string,
  id: string;
  name: string;
  assignedFields: QuotationField[];
}

// Draggable card component (sin cambiar nombre ni comportamiento)
const DraggableField = ({ field }: { field: QuotationField }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: field.id.toString(),
  });

  const style = {
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    padding: 8,
    marginBottom: 8,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: 4,
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <Typography variant="body2">
        <strong>{field.fieldLabel}</strong> ({field.fieldType})
      </Typography>
    </div>
  );
};

// Droppable area component (sin cambiar nombre ni comportamiento)
const DroppableType = ({
  type,
  removeField
}: {
  type: QuotationType;
  removeField: (typeId: string, fieldId: string, relationId: string) => void;
}) => {
  
  const { isOver, setNodeRef } = useDroppable({
    id: type.id.toString(),
  });

  return (
    <Paper
      ref={setNodeRef}
      sx={{
        p: 2,
        minHeight: 200,
        backgroundColor: isOver ? "#e0f7fa" : "#fafafa",
        border: "1px dashed #aaa",
      }}
    >
      <Typography variant="subtitle1">{type.name}</Typography>
      {type.assignedFields.map((f) => (
        <Paper key={f.id} sx={{ p: 1, mt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {f.fieldLabel}
          <IconButton size="small" onClick={() => removeField(type.id, f.id, type.relationId)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Paper>
      ))}
    </Paper>
  );
};

export const AsignarCamposOrdenesServicio = () => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // REDUX (mantengo exactamente los nombres que usabas)
  const { tipoCotizacionesList, tipoCotizacionCamposList }: any = useSelector((state: any) => state.tipoCotizacion);
  const aa: any = useSelector((state: any) => state.tipoCotizacion);
  const { camposOrdenesDeServicio }: any = useSelector((state: any) => state.ordenesDeServicio);




  // USE STATE (nombres intactos)
  const [percentaje, setPercentaje] = React.useState(0);
  const [openTurno, setOpenModal] = useState(false);
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
    msg: "",
    status: "success",
  });

  const [fields, setFields] = useState<any[]>([]);
  const [types, setTypes] = useState<QuotationType[]>([]);

  // CONST STYLES
  const Div = styled("div")(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: "wheat",
    padding: theme.spacing(8),
    textAlign: "center",
  }));

  useEffect(() => {
    getData();
    // no llamo getDataCamposCreados separado: getData ya trae ambos
  }, []);

  const getData = async () => {
    const havePermissions = await hasPemissions("modulo.thumano", "modulo.parametros", "create");

    if (!havePermissions) {
      await validateLsPermissions("No tienes pemisos para (Listar) campos ordenes de servicio.");
      return false;
    }

    // mantengo tus actions
    await dispatch(getAllTipoCotizacionCamposRedux());
    await dispatch(getAllQuotationFieldRedux());
  };

  // cargo catálogo de campos desde el estado original (camposOrdenesDeServicio)
  // useEffect(() => {
  //   if (camposOrdenesDeServicio && camposOrdenesDeServicio.length > 0) {
  //     setFields(camposOrdenesDeServicio);
  //   } else {
  //     setFields([]);
  //   }
  // }, [camposOrdenesDeServicio]);
  useEffect(() => {
  if (fields.length === 0 && camposOrdenesDeServicio?.length > 0) {
    setFields(camposOrdenesDeServicio);
  }
}, [camposOrdenesDeServicio]);

  // ----------------------------
  // Aquí está la pieza clave: 
  // construimos `types` usando:
  // - tipoCotizacionesList  (todos los tipos)
  // - tipoCotizacionCamposList (tabla intermedia)
  // - camposOrdenesDeServicio (catálogo de campos)
  // ----------------------------
  // useEffect(() => {
  //   if (tipoCotizacionesList && tipoCotizacionesList.length > 0) {
  //     const built = tipoCotizacionesList.map((tipo: any) => {
  //       // obtener las relaciones en la tabla intermedia que pertenezcan a este tipo
  //       const relations = Array.isArray(tipoCotizacionCamposList) ? tipoCotizacionCamposList.filter((rel: any) => {
  //         // algunos elementos vienen con quotationTypeId como objeto: { id, name }
  //         const qtId = rel?.quotationTypeId?.id ?? rel?.quotationTypeId;
  //         return qtId === tipo.id || rel?.quotationTypeId?.id === tipo.id;
  //       }) : [];

  //       // mapear relaciones a campos completos desde camposOrdenesDeServicio (catálogo)
  //       const assigned = relations.map((rel: any) => {
  //         const fieldIdFromRel = rel?.fieldTypeId?.id ?? rel?.fieldTypeId;
  //         // buscar en catálogo por id
  //         const full = Array.isArray(camposOrdenesDeServicio) ? camposOrdenesDeServicio.find((c: any) => c.id === fieldIdFromRel) : null;

  //         if (full) {
  //           // si el catálogo tiene fieldLabel, fieldType, etc, úsalo
  //           return {
  //             id: full.id,
  //             fieldLabel: full.fieldLabel ?? full.fieldName ?? full.name ?? String(full.id),
  //             fieldType: full.fieldType ?? full.type ?? "",
  //           } as QuotationField;
  //         }

  //         // si no tenemos catálogo, usamos lo que trae la relación (fieldTypeId)
  //         if (rel?.fieldTypeId) {
  //           return {
  //             id: rel.fieldTypeId.id ?? String(rel.fieldTypeId),
  //             fieldLabel: rel.fieldTypeId.fieldLabel ?? rel.fieldTypeId.fieldName ?? rel.fieldTypeId.fieldName,
  //             fieldType: rel.fieldTypeId.fieldType ?? "",
  //           } as QuotationField;
  //         }

  //         // fallback
  //         return {
  //           id: String(fieldIdFromRel),
  //           fieldLabel: String(fieldIdFromRel),
  //           fieldType: "",
  //         } as QuotationField;
  //       }).filter(Boolean);

  //       return {
  //         id: tipo.id,
  //         name: tipo.name,
  //         assignedFields: assigned,
  //       } as QuotationType;
  //     });

  //     setTypes(built);
  //   } else {
  //     setTypes([]);
  //   }
  // }, [tipoCotizacionesList, tipoCotizacionCamposList, camposOrdenesDeServicio]);


  useEffect(() => {
  if (tipoCotizacionesList && tipoCotizacionesList.length > 0) {
    const built = tipoCotizacionesList.map((tipo: any) => {
      const relations = Array.isArray(tipoCotizacionCamposList)
        ? tipoCotizacionCamposList.filter((rel: any) => {
            const qtId = rel?.quotationTypeId?.id ?? rel?.quotationTypeId;
            return qtId === tipo.id || rel?.quotationTypeId?.id === tipo.id;
          })
        : [];

      // Tomar relationId del primer match (o null si no hay)
      const relationId = relations.length > 0 ? relations[0].id : null;

      const assigned = relations
        .map((rel: any) => {
          const fieldIdFromRel = rel?.fieldTypeId?.id ?? rel?.fieldTypeId;

          const full = Array.isArray(camposOrdenesDeServicio)
            ? camposOrdenesDeServicio.find((c: any) => c.id === fieldIdFromRel)
            : null;

          if (full) {
            return {
              id: full.id,
              fieldLabel:
                full.fieldLabel ?? full.fieldName ?? full.name ?? String(full.id),
              fieldType: full.fieldType ?? full.type ?? "",
            } as QuotationField;
          }

          if (rel?.fieldTypeId) {
            return {
              id: rel.fieldTypeId.id ?? String(rel.fieldTypeId),
              fieldLabel:
                rel.fieldTypeId.fieldLabel ??
                rel.fieldTypeId.fieldName ??
                rel.fieldTypeId.fieldName,
              fieldType: rel.fieldTypeId.fieldType ?? "",
            } as QuotationField;
          }

          return {
            id: String(fieldIdFromRel),
            fieldLabel: String(fieldIdFromRel),
            fieldType: "",
          } as QuotationField;
        })
        .filter(Boolean);

      return {
        relationId: relationId, // 👈 Ahora en la raíz
        id: tipo.id,
        name: tipo.name,
        assignedFields: assigned,
      } as QuotationType & { relationId: string | null };
    });

    setTypes(built);
  } else {
    setTypes([]);
  }
}, [tipoCotizacionesList, tipoCotizacionCamposList, camposOrdenesDeServicio]);



  // handleDragEnd: mantengo la lógica y nombres tuyos
  const handleDragEnd = async (event: DragEndEvent) => {
    const { over, active }: any = event;
    if (!over) return;

    const typeId = over.id;
    const fieldId = active.id;

    const field = fields.find((f) => f.id === fieldId);
    if (!field) return;

    // Obtener tipo actual del estado
    const targetType = types.find((t) => t.id === typeId);
    if (!targetType) return;

    const alreadyAssigned = targetType.assignedFields.some((f: any) => f.id === fieldId);
    if (alreadyAssigned) return;

    // Dispatch al backend (tu acción)
    try {
      await dispatch(
        storeCreateCamposTipoOrdenesServicios(
          {
            quotationTypeId: typeId,
            fieldTypeId: field.id,
          },
          setPercentaje
        )
      );

      // Actualiza el estado después del éxito (mantengo tu setTypes)
      setTypes((prev) =>
        prev.map((t) =>
          t.id === typeId ? { ...t, assignedFields: [...t.assignedFields, field] } : t
        )
      );
    } catch (error) {
      console.error("Error al crear el campo en el backend:", error);
    }
  };

  // removeField: mantengo exactamente tu implementación
  const removeField = async (typeId: string, fieldId: string, relationId: string) => {

    const response = await dispatch(removeCamposTipoOrdenesServicios(relationId));

    if (response.ok) {
      setTypes((prev) =>
        prev.map((t: any) =>
          t.id === typeId
            ? {
                ...t,
                assignedFields: t.assignedFields.filter((f: any) => f.id !== fieldId),
              }
            : t
        )
      );
    }
  };

  // demás funciones intactas
  const openModal = async () => {
    const havePermissionsCreate = await hasPemissions("modulo.thumano", "modulo.parametros", "create");

    if (!havePermissionsCreate) {
      await validateLsPermissions("No tienes pemisos para (Crear) parametros.");
      return false;
    }

    setOpenModal(true);
  };

  const validateLsPermissions = async (message: string) => {
    const errors: any = {
      msg: message,
      status: "error",
    };

    await setMsgSnack(errors);
    await setAlertSnack(true);
  };

  const handleCloseDialog = () => {
    setOpenModal(false);
  };

  return (
    <>
      <CreateDialogTipoCotizacion open={openTurno} handleCloseDialog={handleCloseDialog} />

      <BreadCrumbsAndTitle
        title="Asignar campos a ordenes de servicio"
        mainModule="configuracion"
        parent="Asignar campos a ordenes de servicio"
        action=""
      />

      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button variant="contained" sx={{ marginBottom: 3 }} onClick={openModal}>
          Crear Tipo Cotizacion
        </Button>
      </div>

      <AlertsInformativos type="info" title="info" content={alertInformativo.asignarCamposOrdenesServicios} />
      <Divider sx={{ marginBottom: 5 }} />

      <DndContext onDragEnd={handleDragEnd}>
        <Grid container spacing={2} sx={{ marginTop: paddingCardsTables }}>
          {/* Catálogo de campos */}
          <Grid size={{ xs: 4 }}>
            <Typography variant="h6">Campos disponibles</Typography>
            {fields && fields.length > 0 ? (
              <Box sx={{ p: 2, bgcolor: "#f5f5f5", minHeight: 400 }}>
                {fields.map((field: any) => (
                  <DraggableField key={field.id} field={field} />
                ))}
              </Box>
            ) : (
              <Div>No hay datos disponibles...</Div>
            )}
          </Grid>

          {/* Tipos de cotización */}
         <Grid size={{ xs: 8 }}>
            <Typography variant="h6">Tipos de cotización</Typography>
            {types && types.length > 0 ? (
              <Grid container spacing={2}>
                {types.map((type: any) => (
                  <Grid size={6} key={type.id}>
                    <DroppableType type={type} removeField={removeField} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Div>No hay datos disponibles...</Div>
            )}
          </Grid>

        </Grid>
      </DndContext>
    </>
  );
};
